import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { getPage } from '../services/pageService';

const History = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadHistory = async () => {
      const page = await getPage('history');
      setContent(page?.contentHtml || '');
      setIsLoading(false);
    };
    loadHistory();
  }, []);

  return (
    <>
      <div className="container-fluid page-top">
        <div className="container">
          <div className="row">
            <h2>Historia</h2>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-history">
        <div className="container history">
          <div className="row">
            <div className="col-12">
              {isLoading ? (
                <LoadingSpinner label="Cargando historia..." />
              ) : (
                <div
                  className="history-content"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default History;